import { useEffect, useState } from "react";
import gsap, { Power2 } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import CSSPlugin from 'gsap/CSSPlugin';

if (typeof window !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);
};

export const useImageSectionAnimation = () => {
  const [refresh, setRefresh] = useState(false)
  const imageSectionRefs = [];

  const imageAnimation = (ref: HTMLElement) => {
    gsap.to(ref, {
      autoAlpha: 1,
      scrollTrigger: {
        trigger: ref,
        start: () => `-75% 90%`,
      },
      yPercent: 0,
      duration: 1.4,
      delay: 0.3,
      ease: Power2.easeOut,
    });
  };

  const contentAnimation = (ref: HTMLElement) => {
    gsap.to(ref, {
      autoAlpha: 1,
      scrollTrigger: {
        trigger: ref,
        start: () =>  '-75% 90%',
      },
      yPercent: 0, 
      duration: 0.8, 
      delay: 0.2, 
      ease: Power2.easeOut,
    });
  };

  useEffect(() => {
    if(refresh){
      ScrollTrigger.refresh(true);
    }

    imageSectionRefs.forEach(([img, content], index) => {
      gsap.set(img.current, { yPercent: 100 });
      gsap.set(content.current, { yPercent: 100 });
      imageAnimation(img.current);
      contentAnimation(content.current);
    });
  }, [refresh]);

  return {
    imageSectionRefs,
    setRefresh,
  };
};
